<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 787 294"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="msd" clip-path="url(#clip0_1_97)">
      <g id="Layer 2">
        <g id="Graphics">
          <path
            id="Vector"
            d="M73.513 73.5C73.513 54.0066 81.2581 35.3116 95.0445 21.5277C108.831 7.74373 127.529 0 147.026 0C166.523 0 185.221 7.74373 199.008 21.5277C212.794 35.3116 220.539 54.0066 220.539 73.5H73.513ZM73.513 220.5C73.513 201.007 81.2581 182.312 95.0445 168.528C108.831 154.744 127.529 147 147.026 147C127.529 147 108.831 139.256 95.0445 125.472C81.2581 111.688 73.513 92.9934 73.513 73.5C54.0162 73.5 35.3178 81.2437 21.5315 95.0277C7.7451 108.812 0 127.507 0 147C0 166.493 7.7451 185.188 21.5315 198.972C35.3178 212.756 54.0162 220.5 73.513 220.5ZM73.513 220.5C73.513 239.993 81.2581 258.688 95.0445 272.472C108.831 286.256 127.529 294 147.026 294C166.523 294 185.221 286.256 199.008 272.472C212.794 258.688 220.539 239.993 220.539 220.5H73.513ZM147.026 147C166.523 147 185.221 154.744 199.008 168.528C212.794 182.312 220.539 201.007 220.539 220.5C230.193 220.5 239.752 218.599 248.671 214.905C257.59 211.211 265.694 205.797 272.521 198.972C279.347 192.147 284.762 184.045 288.456 175.127C292.151 166.21 294.052 156.652 294.052 147C294.052 137.348 292.151 127.79 288.456 118.873C284.762 109.955 279.347 101.853 272.521 95.0277C265.694 88.2025 257.59 82.7886 248.671 79.0949C239.752 75.4011 230.193 73.5 220.539 73.5C220.539 92.9934 212.794 111.688 199.008 125.472C185.221 139.256 166.523 147 147.026 147Z"
            :fill="props.fill"
          />
          <path
            id="Vector_2"
            d="M479.354 73.4999H524.898V220.482H491.135V121.629L447.955 220.482L402.5 121.505V220.482H371.012V73.4999H416.023L448.488 149.576L479.354 73.4999ZM645.038 116.921C645.038 87.873 622.702 71.0659 596.012 71.0659C569.322 71.0659 540.695 86.5583 540.695 116.655C540.695 142.754 569.428 156.167 585.83 160.396C594.839 162.777 617.566 165.317 617.566 181.556C617.566 196.995 601.68 201.206 589.792 201.206C574.475 201.206 565.484 190.546 566.798 174.254H536.643C535.595 210.817 560.455 224.444 589.49 225.119C623.057 225.883 648.681 211.546 648.681 179.228C648.681 146.911 619.61 141.617 596.882 134.244C588.175 131.312 571.827 128.772 571.827 113.706C571.827 101.145 582.667 95.1395 593.755 95.1395C607.971 95.1395 615.416 102.246 616.482 116.85H645.038M708.565 73.269H661.706V220.109H708.547C747.48 220.109 787 197.617 787 146.822C787 96.0278 747.48 73.34 708.547 73.34L708.565 73.269ZM706.45 193.388H693.478V100.327H706.45C742.149 100.327 755.032 123.601 755.032 146.893C755.032 170.185 742.132 193.459 706.432 193.459L706.45 193.388Z"
            :fill="props.fill"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1_97">
        <rect width="787" height="294" :fill="props.fill" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  width: {
    type: [Number, String],
    default: 787
  },
  height: {
    type: [Number, String],
    default: 294
  },
  fill: {
    type: String,
    default: '#ffffff'
  }
})
</script>
